import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// TODO refactor, use the same way of sending error messages as on phone and dates
export function detailedEmailValidator(required = true): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const email: string = (control.value || '').trim();

    if (!required && !email) {
      return null;
    }

    if (!/@/.test(email)) {
      return { missingAtSymbol: true, message: 'error.missing_at_symbol' };
    }

    const parts = email.split('@');
    if (parts.length !== 2 || !parts[0] || !parts[1]) {
      return { missingLocalOrDomain: true, message: 'error.missing_local_or_domain' };
    }

    const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!domainPattern.test(parts[1])) {
      return { invalidDomain: true, message: 'error.invalid_domain' };
    }

    const completeEmailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!completeEmailPattern.test(email)) {
      return { invalidEmailFormat: true, message: 'error.invalid_email_format' };
    }

    return null;
  };
}

export function validateDetailedEmail(email: string): boolean {
  if (!/@/.test(email)) {
    return false;
  }

  const parts = email.split('@');
  if (parts.length !== 2 || !parts[0] || !parts[1]) {
    return false;
  }

  const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!domainPattern.test(parts[1])) {
    return false;
  }

  const completeEmailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!completeEmailPattern.test(email)) {
    return false;
  }

  return true;
}
